import { bindServices } from '@/services/api';
import {
  queryCustomListActivate,
  queryCustomListConfigure,
  queryListPermissions,
  querySavePermission,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const api = bindServices('configCustomList');

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'processCustomList',
  state: {
    newCustomList: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    listUserPermission: null,
    listPositionPermission: null,
    listUserGroupPermission: null,
    listAreaPermission: null,
    pagination: meta,
    select: 'id,isActive,order,name,description,type',
    notSelectSearch: 'type,order',
    paramsView: {
      select:
        'id,isActive,order,name,description,type,permissionsFiltersLogicalOperator,preFiltersLogicalOperator,isPublic,created,updated',
      expand: {
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select:
        'id,isActive,order,name,description,type,permissionsFiltersLogicalOperator,preFiltersLogicalOperator,isPublic',
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'customList/paged',
          params: payload,
        });
        yield put({
          type: 'queryCustomLists',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewCustomList({ payload }, { put }) {
      yield put({
        type: 'addCustomList',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewCustomList',
          payload,
        });
      }
    },

    *fetchCustomListConfigure({ payload }, { call, put }) {
      try {
        const table = yield call(queryCustomListConfigure, payload);
        yield put({
          type: 'queryCustomListConfigure',
          payload: {
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *editItemCustomList({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'customList',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editCustomList',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewCustomList({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'customList',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveCustomList',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showCustomListsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditCustomList({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'customList',
          data: payload.data,
        });
        yield put({
          type: 'global/showCustomListsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveCustomList',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showCustomListsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(api.apiRoute, {
          route: `customList/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'global/showCustomListsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveCustomList',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showCustomLists${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemCustomList({ view }, { put }) {
      yield put({
        type: 'showEditItemCustomList',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryCustomListActivate, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /* try */
      }
    },

    *fetchListPermissions({ payload }, { call, put }) {
      try {
        const response = yield call(queryListPermissions, payload);
        yield put({
          type: 'queryPermission',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewPermission({ payload }, { put }) {
      yield put({
        type: 'addPermission',
        payload,
      });
    },

    *addListPermission({ payload }, { put }) {
      yield put({
        type: 'addListPermissions',
        payload,
      });
    },

    *deleteItemPermision({ payload }, { put }) {
      yield put({
        type: 'deleteItemPermisions',
        payload,
      });
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
    },

    *savePermission({ payload }, { call, put }) {
      try {
        yield call(querySavePermission, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'addPermission',
          payload: {
            state: false,
            item: null,
          },
        });
        yield put({
          type: 'hidePermission',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryCustomLists(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addCustomList(state, { payload }) {
      return {
        ...state,
        newCustomList: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewCustomList(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editCustomList(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newPermission: false,
      };
    },
    queryCustomListConfigure(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
      };
    },

    saveCustomList(state, { payload }) {
      return {
        ...state,
        saveCustomList: payload,
        newCustomList: false,
        selectedItem: false,
      };
    },

    showEditItemCustomList(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    customListActive(state, { payload }) {
      return {
        ...state,
        list: _.map(state.list, (o) => {
          if (o.id === payload.id) {
            _.set(o, 'isActive', payload.state);
          }
          return o;
        }),
      };
    },

    addPermission(state, { payload }) {
      return {
        ...state,
        newPermission: payload.state,
        newCustomList: false,
        selectedItem: payload.item,
      };
    },

    queryPermission(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.map(payload.data, (l) => {
          return {
            ...l[payload.field],
            id: l[`${payload.field}Id`],
          };
        }),
      };
    },

    addListPermissions(state, { payload }) {
      return {
        ...state,
        [payload.name]: [...state[payload.name], payload.data],
      };
    },

    deleteItemPermisions(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.filter(state[payload.name], (l) => l.id !== payload.id),
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },

    hidePermission(state) {
      return {
        ...state,
        selectedItem: null,
        listUserPermission: null,
        listPositionPermission: null,
        listUserGroupPermission: null,
        listAreaPermission: null,
        formConfig: null,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newCustomList: false,
        selectedItem: null,
        view: null,
        listUserPermission: null,
        listPositionPermission: null,
        listUserGroupPermission: null,
        listAreaPermission: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
